import Vue from 'vue';
import Router from 'vue-router';

// import Pay from '@/views/common/Pay.vue'; // 支付页
// import Coupon from '@/views/common/Coupon.vue'; // 优惠券
// import auth from '@/views/common/auth.vue'; // 授权
const Pay = resolve => require(['@/views/common/Pay.vue'], resolve);
const Coupon = resolve => require(['@/views/common/Coupon.vue'], resolve);
const auth = resolve => require(['@/views/common/auth.vue'], resolve);

// import HomePage from '@/views/home/HomePage.vue'; // 首页
// import Enrolment from '@/views/home/Enrolment.vue'; // 报名页
// import Confirmation from '@/views/home/Confirmation.vue'; // 信息确认页
// import Notice from '@/views/home/Notice.vue'; // 公告
// import NoticeDetail from '@/views/home/NoticeDetail.vue'; // 公告详情
// const HomePage = resolve => require(['@/views/home/HomePage.vue'], resolve);
const HomePage = resolve => require(['@/views/home/Home.vue'], resolve);
const Enrolment = resolve => require(['@/views/home/Enrolment.vue'], resolve);
const Confirmation = resolve => require(['@/views/home/Confirmation.vue'], resolve);
const Notice = resolve => require(['@/views/home/Notice.vue'], resolve);
const NoticeDetail = resolve => require(['@/views/home/NoticeDetail.vue'], resolve);

// import RecruitIndex from '@/views/recruit/RecruitIndex.vue'; // 招生首页
// import Source from '@/views/recruit/Source.vue'; // 推广素材
// import InvitationCode from '@/views/recruit/InvitationCode.vue'; // 邀请二维码
// import InvitationPage from '@/views/recruit/InvitationPage.vue'; // 邀请信息填写页
// import Poster from '@/views/recruit/Poster.vue'; // 推广海报
// import Achievement from '@/views/recruit/Achievement.vue'; // 我的业绩
// import Fans from '@/views/recruit/Fans.vue'; // 我的粉丝
// import Team from '@/views/recruit/Team.vue'; // 我的团队
// import Cash from '@/views/recruit/Cash.vue'; // 提现
// import CashDetails from '@/views/recruit/CashDetails.vue'; // 提现
const RecruitIndex = resolve => require(['@/views/recruit/RecruitIndex.vue'], resolve);
const Source = resolve => require(['@/views/recruit/Source.vue'], resolve);
const InvitationCode = resolve => require(['@/views/recruit/InvitationCode.vue'], resolve);
const InvitationPage = resolve => require(['@/views/recruit/InvitationPage.vue'], resolve);
const Poster = resolve => require(['@/views/recruit/Poster.vue'], resolve);
const Achievement = resolve => require(['@/views/recruit/Achievement.vue'], resolve);
const Fans = resolve => require(['@/views/recruit/Fans.vue'], resolve);
const Team = resolve => require(['@/views/recruit/Team.vue'], resolve);
const Cash = resolve => require(['@/views/recruit/Cash.vue'], resolve);
const CashDetails = resolve => require(['@/views/recruit/CashDetails.vue'], resolve);
const Preview = resolve => require(['@/views/recruit/Preview.vue'], resolve);
const PreviewPay = resolve => require(['@/views/recruit/PreviewPay.vue'], resolve);
const EnrolledDetail = resolve => require(['@/views/recruit/EnrolledDetail.vue'], resolve);
const Questions = resolve => require(['@/views/recruit/Questions.vue'], resolve);


// import Mine from '@/views/mine/Mine.vue'; // 我的
// import Personal from '@/views/mine/Personal.vue'; // 我的信息
// import Course from '@/views/mine/Course.vue'; // 我的课程
// import OnlineCourseList from '@/views/mine/OnlineCourseList.vue'; // 线上课程列表
// import CourseDetail from '@/views/mine/CourseDetail.vue'; // 线上课程详情
// import Order from '@/views/mine/Order.vue'; // 我的订单
// import Process from '@/views/mine/Process.vue'; // 报读流程
// import Address from '@/views/mine/Address.vue'; // 我的地址
// import Teacher from '@/views/mine/Teacher.vue'; // 我的老师
const Mine = resolve => require(['@/views/mine/Mine.vue'], resolve);
const Personal = resolve => require(['@/views/mine/Personal.vue'], resolve);
const Course = resolve => require(['@/views/mine/Course.vue'], resolve);
const OnlineCourseList = resolve => require(['@/views/mine/OnlineCourseList.vue'], resolve);
const CourseDetail = resolve => require(['@/views/mine/CourseDetail.vue'], resolve);
const Order = resolve => require(['@/views/mine/Order.vue'], resolve);
const Process = resolve => require(['@/views/mine/Process.vue'], resolve);
const Untie = resolve => require(['@/views/mine/Untie.vue'], resolve);
const Address = resolve => require(['@/views/mine/Address.vue'], resolve);
const Teacher = resolve => require(['@/views/mine/Teacher.vue'], resolve);

// import Canvas from '@/views/recruit/Canvas.vue'; // test
const Canvas = resolve => require(['@/views/recruit/Canvas.vue'], resolve);

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: 'home' },
    {
      path: '/home', name: 'HomePage', component: HomePage,
      children: [
        { path: 'GetCoupon', name: 'GetCoupon', component: () => import('@/components/Henrolment.vue') },
      ]
    },
    { path: '/Enrolment', name: 'Enrolment', component: Enrolment },
    { path: '/Confirmation', name: 'Confirmation', component: Confirmation },
    {
      path: '/Notice', component: Notice,
      children: [
        { path: 'NoticeCard', component: () => import('@/views/home/NoticeCard.vue') },
        { path: 'NewsCard', component: () => import('@/views/home/NewsCard.vue') },
        { path: '', name: 'Notice', redirect: 'NewsCard' }
      ]
    },
    { path: '/NoticeDetail', name: 'NoticeDetail', component: NoticeDetail },

    { path: '/RecruitIndex', name: 'RecruitIndex', component: RecruitIndex },
    { path: '/Source', name: 'Source', component: Source },
    { path: '/InvitationCode', name: 'InvitationCode', component: InvitationCode },
    { path: '/Poster', name: 'Poster', component: Poster },
    { path: '/InvitationPage', name: 'InvitationPage', component: InvitationPage },
    {
      path: '/Achievement', component: Achievement,
      children: [
        { path: 'AchiPre', component: () => import('@/components/AchiPre.vue') },
        { path: 'AchiTeam', component: () => import('@/components/AchiTeam.vue') },
        { path: '', name: 'Achievement', redirect: 'AchiPre' }
      ]
    },
    { path: '/Fans', name: 'Fans', component: Fans },
    {
      path: '/Team', component: Team,
      children: [
        { path: 'LevelOne', component: () => import('@/views/recruit/LevelOne.vue') },
        { path: 'LevelTwo', component: () => import('@/views/recruit/LevelTwo.vue') },
        { path: 'LevelOther', component: () => import('@/views/recruit/LevelOther.vue') },
        { path: '', name: 'Team', redirect: 'LevelOne' }
      ]
    },
    { path: '/Cash', name: 'Cash', component: Cash },
    { path: '/CashDetails', name: 'CashDetails', component: CashDetails },
    {
      path: '/Preview', component: Preview,
      children: [
        { path: 'PreAdd', component: () => import('@/components/PreAdd.vue') },
        { path: 'PreNotRegistered', component: () => import('@/components/PreNotRegistered.vue') },
        { path: 'PreEnrolled', component: () => import('@/components/PreEnrolled.vue') },
        { path: '', name: 'Preview', redirect: 'PreAdd' }
      ]
    },
    { path: '/PreviewPay', name: 'PreviewPay', component: PreviewPay },
    { path: '/EnrolledDetail', name: 'EnrolledDetail', component: EnrolledDetail },

    { path: '/Mine', name: 'Mine', component: Mine },
    { path: '/Personal', name: 'Personal', component: Personal },
    { path: '/Course', name: 'Course', component: Course },
    { path: '/OnlineCourseList', name: 'OnlineCourseList', component: OnlineCourseList },
    { path: '/CourseDetail', name: 'CourseDetail', component: CourseDetail },
    { path: '/Order', name: 'Order', component: Order },
    { path: '/Process', name: 'Process', component: Process },
    { path: '/Untie', name: 'Untie', component: Untie },
    { path: '/Address', name: 'Address', component: Address },
    { path: '/Teacher', name: 'Teacher', component: Teacher },

    { path: '/auth', name: 'auth', component: auth },
    { path: '/Pay', name: 'Pay', component: Pay },
    { path: '/Coupon', name: 'Coupon', component: Coupon },
    { path: '/Questions', name: 'Questions', component: Questions },

    { path: '/Canvas', name: 'Canvas', component: Canvas }, // 测试

    // 兜底：任何匹配不到的路径一律回首页。
    // 原来没有这条，访问不存在的地址（比如把 /mine 打成 /mime）时
    // <router-view/> 没有任何组件可渲染，页面就是纯白且无任何报错，很难排查。
    { path: '*', redirect: '/home' },
  ],
});

router.beforeEach((to, from, next) => {
  let token = JSON.parse(localStorage.getItem('cww_data'));
  // console.log(to.fullPath)


  // 测试服务器

  if (!token && _IsInArray(to.name) == -1) {
    let base = localStorage.getItem('cww_url')
    const baseUrl = base || 'https://gk.zhenzhang.com';

    let APPID = 'wxf6fa8b38910cd4ae'; // 线上环境
    if (baseUrl === 'https://gk.zhenzhang.com' || baseUrl === 'http://gk.zhenzhang.com') {
      APPID = 'wxf6fa8b38910cd4ae'; // 线上环境
    } else {
      APPID = 'wxf0f8188a9758606c'; // 测试服务器
    }


    let REDIRECT_URI = encodeURIComponent(`${baseUrl}/auth`);
    sessionStorage.setItem('beforeUrl', to.fullPath);
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  }else{
    next();
  }
})

// 页面白名单inArr
function _IsInArray(val) {
  let inArr = ['auth', 'Untie']
  var testStr = ',' + inArr.join(',') + ','
  return testStr.indexOf(',' + val + ',')
}

export default router;
